const typePlayers = ["Capitán", "Subcapitán", "Jugador 3", "Jugador 4", "Jugador 5", "Jugador 6"]
export default typePlayers